import type {FormattedImageLinkParams} from './types';

export const formattedImageLink = async ({linkImage = '', linkVideo}: FormattedImageLinkParams) => {
	const regex = /\.(jpe?g|png|gif|bmp|webp|svg|tiff?|ico)$/i;

	if (!regex.test(linkImage)) {
		const videoId = linkVideo.split('v=')[1];
		if (videoId) {
			const maxResUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
			const hqDefaultUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

			const maxResExists = await checkImageExists(maxResUrl);
			if (maxResExists) {
				return maxResUrl;
			}

			return hqDefaultUrl;
		}
	}
	return linkImage;
};

const checkImageExists = async (url: string) => {
	try {
		const controller = new AbortController();
		const timeoutId = setTimeout(() => controller.abort(), 3000);

		const response = await fetch(url, {
			method: 'HEAD',
			signal: controller.signal,
		});

		clearTimeout(timeoutId);
		return response.ok;
	} catch (error) {
		return false;
	}
};
